<template>
	<div class="app-main">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>联系人信息</span>
		</div>
		<div style="padding-bottom: 5px;">
			<el-alert description="提示: 真实的联系人信息便于合作企业快速联系您，至少需要维护一条默认联系人。">
			</el-alert>
		</div>
		<el-row class="mg-b5">
			<el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle">
				<el-table-column prop="name" label="姓名" :show-overflow-tooltip="true" width="120"></el-table-column>
				<el-table-column prop="sex" label="性别" :show-overflow-tooltip="true" width="120"></el-table-column>
				<el-table-column prop="email" label="邮箱" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="phone" label="手机号码" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="deptName" label="部门" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="gw" label="职位" :show-overflow-tooltip="true" width="120"></el-table-column>
				<el-table-column prop="fixedPhone" label="固定电话" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="ywDb" label="业务代表" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="zjType" label="证件类型" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="zjCode" label="证件号码" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="remark" label="备注" :show-overflow-tooltip="true"> </el-table-column>
				<el-table-column label="操作" width="100" align="center" fixed="right">
					<template slot="header" slot-scope="scope">
						<el-button size="small" plain type="primary" @click="handleAdd">新增
						</el-button>
					</template>
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="handleEdit(scope.row)">修改
						</el-button>
						<el-button type="text" size="small" @click="handleDel(scope.row.rowId)">删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-row>
		<div v-if="!preview" style="text-align: center;">
			<span slot="footer" class="dialog-footer">
				<el-button @click="backStep" size="small">上一步</el-button>
				<el-button type="primary" @click="nextStep" size="small">下一步</el-button>
			</span>
		</div>
		<el-dialog :visible.sync="openDialog" width="800px" :title="title" :close-on-click-modal="false">
			<el-form label-width="100px" ref="form" :model="form" :rules="rules" size="small">
				<el-row>
					<el-col :span="12">
						<el-form-item label="姓名" prop="name">
							<el-input v-model="form.name" placeholder="请输入姓名" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="邮箱" prop="email">
							<el-input v-model="form.email" placeholder="请输入邮箱" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="性别" prop="sex">
							<el-radio-group v-model="form.sex">
								<el-radio label="男">男</el-radio>
								<el-radio label="女">女</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="手机号码" prop="phone">
							<el-input v-model="form.phone" placeholder="请输入手机号码" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="部门" prop="deptName">
							<el-input v-model="form.deptName" placeholder="请输入部门" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="职位" prop="gw">
							<el-input v-model="form.gw" placeholder="请输入职位" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="固定电话" prop="fixedPhone">
							<el-input v-model="form.fixedPhone" placeholder="请输入固定电话" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="业务代表" prop="ywDb">
							<el-input v-model="form.ywDb" placeholder="请输入业务代表" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="证件类型" prop="zjType">
							<el-select v-model="form.zjType" placeholder="请选择证件类型" style="width: 100%">
								<el-option label="居民身份证" value="居民身份证"></el-option>
								<el-option label="士官证" value="士官证"></el-option>
								<el-option label="驾驶证" value="驾驶证"></el-option>
								<el-option label="护照" value="护照"></el-option>
								<el-option label="港澳通行证" value="港澳通行证"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="证件号码" prop="zjCode">
							<el-input v-model="form.zjCode" placeholder="请输入证件号码" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="备注" prop="remark">
							<el-input v-model="form.remark" type="textarea" rows="1" placeholder="请输入备注" />
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="openDialog = false" size="small">取 消</el-button>
				<el-button type="primary" @click="submitForm" size="small">保 存</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		supplierContactsList,
		addSupplierContacts,
		editSupplierContacts,
		delSupplierContacts,
	} from '@/api/gys/supplierContacts.js'
	import{addSupplierApprovalMx, getSupplierApprovalMx} from '@/api/gys/supplierInfo.js'
	import { createHash } from '@/utils/index'
	export default {
		name: "SupplierContacts1",
		computed: {},
		props: {
			basicId: {
				type: Number,
			},
			preview: {
				type: Boolean,
				default: false
			},
			otherInfo: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
				title: "",
				tableData: [],
				form: {},
				loadingInstance: undefined,
				openDialog: false,
				count: 0,
				quertInfo: {
					page: 1, //当前页码
					limit: 1000, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: '',
						hId: this.basicId,
					}
				},
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					sex: [{
						required: true,
						message: '请输入性别',
						trigger: 'blur'
					}],
					email: [{
							required: true,
							message: '请输入邮箱',
							trigger: 'blur',
						},
						{
							pattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
							message: "邮箱格式不正确",
							trigger: "blur"
						}
					],
					phone: [{
							required: true,
							message: "手机号码不能为空",
							trigger: "blur"
						},
						{
							pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
							message: "请输入正确的手机号码",
							trigger: "blur"
						}
					],
					zjType:[{
						required: true,
						message: '请选择证件类型',
						trigger: 'blur'
					}],
					zjCode:[{
						required: true,
						message: '请输入证件号码',
						trigger: 'blur'
					}],
				}
			};
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList() {
				let _this = this;
				let pramar = {
					classType:'com.srm.entity.SupplierContacts',
					classTypeIndex:'0',
					supplierInfoId:_this.basicId,
				};
				if(this.otherInfo.lastPass){
					pramar['queryType']='lastPass'
				}
				getSupplierApprovalMx(pramar).then(({data:res}) => {
					console.log(res)
					this.tableData = [];
					if(res.data && res.data.jsonData){
						this.tableData = JSON.parse(res.data.jsonData)
					}
				})
			},
			onSearch: function() {
				//重置页码（会出现查询搜索字段在当前页码之前，会查询不到）
				this.quertInfo.page = 1;
				this.getList();
			},
			// 表单重置
			reset: function() {
				this.form = {
					id: undefined,
					createTime: undefined,
					createUser: this.$store.getters['user/user'].id,
					name: undefined,
					sex: undefined,
					email: undefined,
					phone: undefined,
					deptName: undefined,
					gw: undefined,
					fixedPhone: undefined,
					ywDb: undefined,
					zjType: undefined,
					zjCode: undefined,
					remark: undefined,
					hId: this.basicId,
				}
				if (this.$refs["form"] !== undefined) {
					this.$refs["form"].resetFields();
				}
			},
			submitForm() {
				let _this = this;
				_this.$refs['form'].validate((valid) => {
					if (valid) {
						let oldData = JSON.parse(JSON.stringify(_this.tableData))
						let data = JSON.parse(JSON.stringify(_this.form));
						if (data.rowId != undefined) {
							let num = -1;
							oldData.forEach((nItem,index)=>{
								if(nItem.rowId == data.rowId){
									num = index;
								}
							})
							if(num>=0){
								oldData[num] = data;
							}
							_this.addFun(oldData);
						} else {
							data.rowId = createHash();
							oldData.push(data)
							// console.log(oldData)
							_this.addFun(oldData);
						}
					}
				});
			},
			addFun(data){
				let _this = this;
				addSupplierApprovalMx({
					classType:'com.srm.entity.SupplierContacts',
					classTypeIndex:'0',
					supplierInfoId:this.basicId,
					jsonData:JSON.stringify(data)
				}).then((res)=>{
					_this.$success('添加成功');
					_this.openDialog = false;
					_this.getList();
				})
			},
			handleAdd: function() {
				this.reset();
				this.title = "新增";
				this.openDialog = true;
			},
			handleEdit: function(row) {
				this.reset();
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
				this.openDialog = true;
			},
			//上一步
			backStep: function() {
				this.bus.$emit('stepsFun', 2);
			},
			//下一步
			nextStep: function() {
				if (this.tableData.length <= 0) {
					this.$notify({
						message: '公司默认联系人必须有且仅有一个，请及时修改！',
						type: 'error'
					});
					return false;
				}
				this.bus.$emit('stepsFun', 4);
			},
			handleDel: function(id) {
				let _this = this;
				let oldData = JSON.parse(JSON.stringify(_this.tableData))
				let newData = [];
				oldData.forEach((item)=>{
					if(item.rowId != id){
						newData.push(item)
					}
				})
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						_this.addFun(param);
					},
					data: newData//参数对象 主要回调函数用
				});
			},
			beforeExcel(file) {
				// 判断文件后缀
				let type = file.name.substring(file.name.lastIndexOf('.') + 1);
				if (!(type == "xls" || type == "xlsx")) {
					this.$fail('请导入Excel文件');
					return false;
				}

				const isLt2M = file.size / 1024 / 1024 <= 1;
				if (!isLt2M) {
					this.$fail('导入Excel不能超过 1MB!');
					return false;
				}
				this.loadingInstance = this.Loading({
					text: '导入中请等待...'
				});
			},
		}
	};
</script>
<style scoped="scoped">
</style>
